var map = {
	"./aperture.svg": "cPq8",
	"./droplet.svg": "lYqr",
	"./github.svg": "z6R7",
	"./heart.svg": "q9dO",
	"./language.svg": "+Dip",
	"./layers.svg": "cWNl",
	"./password.svg": "QjmH",
	"./pifu.svg": "ekAn",
	"./type.svg": "Kg5v",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 21